<template>
  <a-card title="Cài đặt service" class="root-card">
    <a-form-model ref="form" :rules="rules" :model="serviceSetting" :label-col="{ span: 1 }" :wrapper-col="{ span: 6 }">
      <a-form-model-item label="URI" prop="uri" has-feedback :validate-status="validateUriStatus">
        <a-input v-model="serviceSetting.uri" @change="onChangeServiceUriInput" allow-clear :placeholder="defaultServiceUri"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 12, offset: 1 }">
        <a-button type="default" @click="setDefaultServiceUri">
          <a-icon type="redo" /> Đặt lại
        </a-button>
        <a-button type="primary" @click="saveServiceUri" style="margin-left: 10px;">
          <a-icon type="save" /> Lưu lại
        </a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

function isOriginWithoutPath(str) {
  try {
    const url = new URL(str);
    return url.pathname === '/' && !str.endsWith('/');
  } catch (error) {
    return false;
  }
}

export default {
  data() {
    let validateUri = (rule, value, callback) => {
      if (isOriginWithoutPath(value)) {
        this.validateUriStatus = 'success';
        return callback();
      }

      this.validateUriStatus = 'error';

      if (value == '') {
        return callback(new Error('Vui lòng nhập service_uri!'));
      }

      return callback(new Error('Service_uri không đúng định dạng!'));
    }

    return {
      serviceSetting: {
        uri: ''
      },
      rules: {
        uri: [{ validator: validateUri, trigger: 'change' }]
      },
      validateUriStatus: 'success',
      defaultServiceUri: location.protocol + '//' + location.hostname + ':3000'
    }
  },
  computed: {
    ...mapGetters('setting', {
      serviceUri: 'getServiceUri'
    }),
  },
  mounted() {
    this.serviceSetting.uri = this.serviceUri;

    if (isOriginWithoutPath(this.serviceSetting.uri)) {
      this.validateUriStatus = 'success';
    } else {
      this.validateUriStatus = 'error';
    }
  },
  methods: {
    ...mapActions('setting', {
      setServiceUri: 'setServiceUri'
    }),

    onChangeServiceUriInput() {
      if (isOriginWithoutPath(this.serviceSetting.uri)) {
        this.validateUriStatus = 'success';
      } else {
        this.validateUriStatus = 'error';
      }
    },

    saveServiceUri() {
      if (this.validateUriStatus == 'success') {
        this.setServiceUri(this.serviceSetting.uri);
        this.$message.success('Lưu service_uri thành công!');
      } else {
        this.$message.warning('Service_uri không đúng định dạng!');
      }
    },

    setDefaultServiceUri() {
      const defaultServiceUri = this.defaultServiceUri;
      this.setServiceUri(defaultServiceUri);
      this.serviceSetting.uri = defaultServiceUri;
      this.$refs['form'].validate();
    }
  }
}
</script>
